import { getIntDate } from '@/views/analysis/common.js'
export default {
  titleTxt: [
    {
      title: '地域分布',
      tipTxt: '在选定的查询条件以及时间周期内，您可以看到达人主要集中在哪些省份或城市'
    },
    {
      title: '粉丝量级',
      tipTxt: '在选定的查询条件以及时间周期内，您可以看到不同粉丝量级的达人分别有多少。'
    },
    {
      title: '达人圈层',
      tipTxt: '在选定的查询条件以及时间周期内，您可以看到不同达人圈层的达人分别有多少。'
    },
    {
      title: '互动成本',
      tipTxt: '在选定的查询条件以及时间周期内，您可以看到不同互动成本分段的达人分别有多少。'
    },
    {
      title: '内容类型',
      tipTxt: '在选定的查询条件以及时间周期内，您可以看到不同内容类型的达人分别有多少。'
    },
    {
      title: '达人排行',
      tipTxt: '在选定的查询条件以及时间周期内，您可以根据不同指标对达人进行排名，并了解其具体信息。'
    }
  ],
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      flagKey: 'isPrereport',
      id: 'name',
      name: 'name'
    }
  ],
  filterForm: [
    {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '平台',
      width: '200px',
      intintValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'brand',
      label: '品牌',
      width: '200px',
      intValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'lineName',
      label: '产线',
      placeholder: '综合',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'isPrereport',
      label: '是否报备',
      placeholder: '全部',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'tab',
      id: 'timeType',
      label: '选择时间',
      intValue: '0',
      children: [{
        id: '0',
        name: '月报',
        showItemId: 'dateMonth',
        hideItemId: 'dateTime'
      }, {
        id: '1',
        name: '日报',
        showItemId: 'dateTime',
        hideItemId: 'dateMonth'
      }]
    }, {
      type: 'month',
      isHide: false,
      format: 'yyyy年 MM月',
      valueFormat: 'yyyy-MM',
      clearable: true,
      id: 'dateMonth',
      label: '',
      width: '160px',
      // intValue: '2021-12'
      intValue: getIntDate()
    }, {
      type: 'datesRange',
      dateType: 'date',
      isHide: true,
      clearable: true,
      id: 'dateTime',
      startTimeId: 'dateTimeStartTime',
      endTimeId: 'dateTimeEndTime',
      label: '',
      width: '390px',
      intValue: ['', '']
    }
  ],
  formRules: {
    brand: [
      {
        required: true,
        message: '请选择'
      }
    ]
  },
  fanweightList: [
    {
      name: '<=1w',
      sumKey: '',
      sum: '31355',
      color: '#326CFA'
    }
  ],
  talentCircleList: [
    {
      dataTime: '美食',
      indicator: '100',
      addCompare: 210
    }
  ],
  sortIndex: [],
  sortRules: [{
    name: '降序',
    id: '1'
  }, {
    name: '升序',
    id: '2'
  }],
  // 内容列表数据 - 表头
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '80',
      fixed: true
    }, {
      label: '达人名称',
      key: 'authName',
      fixed: true
    }, {
      label: '地域',
      key: 'authArea'
    }, {
      label: '粉丝数',
      key: 'follower'
    }, {
      label: '粉丝量级',
      key: 'followerLevel'
    }, {
      label: '获赞与收藏量',
      key: 'authLikeCollcet',
      txtAlign: 'right',
      rightWidth: 180
    }, {
      label: '达人量级',
      key: 'authLevel'
    }, {
      label: '达人圈层',
      key: 'authCircle'
    }, {
      label: '内容数',
      key: 'articleNum',
      txtAlign: 'right'
    }, {
      label: '爆款数',
      key: 'popularNum',
      txtAlign: 'right'
    }, {
      label: '爆款率',
      key: 'popularRate',
      txtAlign: 'right'
    }, {
      label: '曝光数',
      key: 'exposeNum',
      txtAlign: 'right'
    }, {
      label: '阅读量',
      key: 'readNum',
      txtAlign: 'right'
    }, {
      label: '点赞数',
      key: 'likeNum',
      txtAlign: 'right'
    }, {
      label: '收藏数',
      key: 'subscribeNum',
      txtAlign: 'right'
    }, {
      label: '评论数',
      key: 'commentNum',
      txtAlign: 'right'
    }, {
      label: '互动量',
      key: 'interactNum',
      txtAlign: 'right'
    }, {
      label: '互动率',
      key: 'interactRate',
      txtAlign: 'right'
    }, {
      label: '互动成本',
      key: 'interactCost',
      txtAlign: 'right'
    }, {
      label: '内容类型 - 内容数',
      children: [
        {
          label: '测评',
          key: 'contentTypeTest'
        }, {
          label: '好物推荐',
          key: 'contentTypeRecomment',
          width: 100
        }, {
          label: '横评',
          key: 'contentTypeHeng'
        }, {
          label: '使用体验',
          key: 'contentTypeUse',
          width: 100
        }, {
          label: '选购',
          key: 'contentTypeChoose'
        }
      ]
    }, {
      label: '内容选题 - 内容数',
      children: [
        {
          label: '达人原创',
          key: 'themeAuth',
          width: 100
        }, {
          label: '品牌方规定',
          key: 'themeBrand',
          width: 120
        }, {
          label: '平台热点',
          key: 'themePlatform',
          width: 100
        }, {
          label: '双方共创',
          key: 'themeCreat',
          width: 100
        }, {
          label: '双方共创/日常',
          key: 'themeCommand',
          width: 160
        }
      ]
    }, {
      label: '内容场景 - 内容数',
      children: [
        {
          label: '门店',
          key: 'sceneShop'
        }, {
          label: '素材剪辑',
          key: 'sceneSource',
          width: 100
        }, {
          label: '真实用户',
          key: 'sceneRealUser',
          width: 100
        }, {
          label: '伪真实用户',
          key: 'scenePseudoUser',
          width: 120
        }
      ]
    }
  ],
  mapData: [
    {
      name: '河北',
      value: '84927',
      remark: '河北省'
    }
  ]
}
